//import HomeIcon from '@mui/icons-material/Home';
//import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
//import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
//import AccountCircleIcon from '@mui/icons-material/AccountCircle';
//import SettingsIcon from '@mui/icons-material/Settings';

export const listMenu = [
  {
    id: 1,
    name: "Home",
    icon: <span className="lnr lnr-home icon-bottom-bar"></span>,
    path: "/",
  },
  {
    id: 3,
    name: "Esplora",
    icon: <span className="lnr lnr-magnifier icon-bottom-bar"></span>,
    path: "/explore",
  },
  {
    id: 4,
    name: "Calendario",
    icon: <span className="lnr lnr-calendar-full icon-bottom-bar"></span>,
    path: "/calendar",
  },
  {
    id: 5,
    name: "Notifiche",
    icon: <span className="lnr lnr-alarm icon-bottom-bar"></span>,
    path: "/notifications",
  },
  {
    id: 2,
    name: "Gestisci",
    icon: <span className="lnr lnr-magic-wand icon-bottom-bar"></span>,
    path: "/dashboard",
  },
];
